import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { HorizonLogger } from '@bayclubs/horizon';

@Injectable({
    providedIn: 'root'
})
export class LoggingService {
    constructor(private loggingService: HorizonLogger) {}

    public logApplicationError(error: Error | HttpErrorResponse, message?: string): void {
        if (this.shouldLogError(error)) {
            this.logError(message, error);
        } else {
            this.logErrorAsInfo(message, error);
        }
    }

    public logErrorAsInfo(message: string, error: Error | HttpErrorResponse, customProperties?: any): void {
        message = message || error.message;

        this.loggingService.info(message, {
            error: this.extractErrorDetails(error),
            correlationId: this.extractCorrelationId(error),
            ...customProperties
        });
    }

    public logError(msg: string, error?: Error | HttpErrorResponse, customProperties?: any): void {
        this.loggingService.error(msg, error, this.extractCorrelationId(error), customProperties);
    }

    public logWarn(msg: string, customProperties?: any, error: string = null, correlationId: string= null): void {
        this.loggingService.warn(msg, error, correlationId, customProperties);
    }

    public logApplicationInfo(msg: string, customProperties?: any): void {
        this.loggingService.info(msg, customProperties);
    }

    private shouldLogError(error: Error | HttpErrorResponse): boolean {
        if (error instanceof HttpErrorResponse) {
            if (error.status >= 400 && error.status < 500) {
                return false;
            }
        }

        return true;
    }

    private extractCorrelationId(error: Error | HttpErrorResponse) {
        if (!error) {
            return null;
        }

        if (error instanceof HttpErrorResponse) {
            if (error && error.error) {
                return error.error.CorrelationId;
            }
        }
        return null;
    }

    private extractErrorDetails(error: Error | HttpErrorResponse): string {
        if (!error) {
            return null;
        }

        if (error instanceof Error) {
            return error.stack;
        } else {
            return JSON.stringify(error);
        }
    }
}
